import { render } from "./TheHeader.vue?vue&type=template&id=1d74d543"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
script.render = render

export default script